type ClearableKnockStatus = {
  status: string
  note: string | null
  createdTime?: string | Date | null
  createdByName?: string | null
}

// SH-1781: bubbles don't reliably refetch after a clear, so blank the
// displayed fields locally instead of showing stale pre-clear values.
export function applyClearedOverride<T extends ClearableKnockStatus>(
  knockStatus: T,
  cleared: boolean,
): T {
  if (!cleared) return knockStatus
  return {
    ...knockStatus,
    status: '',
    note: null,
    createdTime: null,
    createdByName: null,
  }
}
